import RoleContext from "../context/Context";
import Grid from "@mui/material/Grid2";
import React, { useContext } from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

interface NameAreaProps {
  canEdit?: boolean;
}

const NameArea = (props: NameAreaProps): React.JSX.Element => {
  const { canEdit } = props;
  const { role, setRole } = useContext(RoleContext);
  const { t } = useTranslation();

  const onChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRole((old) => {
      return { ...old, [event.target.name]: event.target.value };
    });
  };

  return (
    <Grid container direction="column" sx={{ width: "100%", gap: 1 }}>
      <Grid>
        <TextField
          required
          type="text"
          name="name"
          fullWidth
          value={role?.name ?? ""}
          onChange={onChange}
          label={t("Name")}
          disabled={!canEdit}
          slotProps={{
            htmlInput: { maxLength: 255 },
          }}
        />
      </Grid>
      <Grid>
        <TextField
          type="text"
          multiline
          name="description"
          fullWidth
          value={role?.description ?? ""}
          onChange={onChange}
          label={t("Description")}
          disabled={!canEdit}
        />
      </Grid>
    </Grid>
  );
};

export default NameArea;
